<template>
    <div class="payable_statistics_wrap" v-loading="loading">
        <el-tabs v-model="tabActiveName" @tab-click="handleClickTab">
            <el-tab-pane v-for="item in tabList" :label="item.label" :name="item.name"> </el-tab-pane>
        </el-tabs>
        <div class="content_right_wrap">
            <div class="page-filter_wrap">
                <div class="page-filter_wrap_left">
                    <el-input
                        v-model="searchForm.keyword"
                        class="filter-input"
                        clearable
                        placeholder="请输入您想搜索的内容"
                        @clear="handleClickSearch"
                        @keyup.enter.native="handleClickSearch"
                    >
                        <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                    </el-input>
                    <!-- <el-select
                        v-model="searchForm.dateType"
                        placeholder="请选择"
                        size="small"
                        @change="handleClickDateChange"
                    >
                        <el-option label="本月" value="month"></el-option>
                        <el-option label="本季度" value="quarter"></el-option>
                        <el-option label="本年" value="year"></el-option>
                        <el-popover placement="bottom" ref="customDatePopover" trigger="click" width="375">
                            <el-option label="自定义日期" value="customDate" slot="reference"></el-option>
                            <el-date-picker
                                v-model="searchForm.customDate"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                range-separator="-"
                                size="small"
                                start-placeholder="开始日期"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                @change="handleCustomDateChange"
                            >
                            </el-date-picker>
                        </el-popover>
                    </el-select> -->
                    <el-date-picker
                        v-model="searchForm.date_range"
                        :clearable="false"
                        :picker-options="pickerOptions"
                        align="right"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd"
                        range-separator="-"
                        size="small"
                        start-placeholder="开始日期"
                        type="daterange"
                        unlink-panels
                        value-format="yyyy-MM-dd"
                        @change="handleClickSearch"
                    >
                    </el-date-picker>
                </div>
            </div>
            <div class="page-content">
                <ul class="static_num_top" v-if="tabActiveName == 'payableSummary'">
                    <li>
                        <p>应付汇总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_payable_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>已付汇总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_paid_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>应付未付汇总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_unpaid_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>取消汇总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_canceled_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                </ul>
                <ul class="static_num_top" v-else-if="tabActiveName == 'purchase'">
                    <li>
                        <p>采购应付总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_payable_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>采购已付总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_paid_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>采购未付总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_unpaid_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>取消总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_canceled_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                </ul>
                <ul v-else-if="tabActiveName == 'order_return'" class="static_num_top">
                    <li>
                        <p>订单退款应付总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_payable_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>订单退款已付总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_paid_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>订单退款未付总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_unpaid_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>订单退款取消总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_canceled_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                </ul>
                <ul class="static_num_top" v-else>
                    <li>
                        <p>{{ chartTooltipTitle }}应付总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_payable_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>{{ chartTooltipTitle }}已付总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_paid_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>{{ chartTooltipTitle }}未付总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_unpaid_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>{{ chartTooltipTitle }}取消总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.total_canceled_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                </ul>
                <div class="chart_box">
                    <div
                        class="chart_item_box"
                        :class="tabActiveName === 'payableSummary' ? 'chart_item_box_flex' : 'chart_item_box_bar'"
                    >
                        <div class="chart_box_title">
                            <span>{{ tabList.find((item) => item.name === tabActiveName).chartTitle }}</span>
                            <div class="chart_box_title_right">
                                <span
                                    v-for="item in chartDateTypeList"
                                    :key="item.type"
                                    :class="{ active: chartDateType === item.type }"
                                    @click="handleClickChartType(item.type)"
                                    >{{ item.name }}</span
                                >
                            </div>
                        </div>
                        <div class="chart_box_bottom">
                            <div class="echarts_container" id="container1"></div>
                        </div>
                    </div>
                    <div class="chart_item_box chart_item_box_pie" v-if="tabActiveName === 'payableSummary'">
                        <div class="chart_box_title">
                            <span>各业务应付总金额占比</span>
                        </div>
                        <div class="chart_box_bottom">
                            <div class="echarts_container" id="container2"></div>
                        </div>
                    </div>
                </div>
                <el-table
                    ref="payableStatisticsTable"
                    :data="summaryData.list_data"
                    border
                    class="custom_table"
                    size="small"
                >
                    <template v-if="tabActiveName == 'payableSummary'">
                        <el-table-column
                            label="收款方/供应商名称/客户公司"
                            min-width="380"
                            prop="payable_num1"
                            show-overflow-tooltip
                            key="1"
                        >
                            <template slot-scope="{ row }">
                                <span
                                    class="link-label"
                                    v-if="row.entity_type == 'customer'"
                                    @click="handleClickCustomerDetail(row.entity_id, row.entity_name)"
                                    >{{ row.entity_name }}</span
                                >
                                <span v-else>{{ row.entity_name }}</span>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="tabActiveName === 'purchase'">
                        <el-table-column
                            key="2"
                            label="供应商名称"
                            min-width="380"
                            prop="supplier_name"
                            show-overflow-tooltip
                        >
                            <template slot-scope="{ row }">
                                <span>{{ row.supplier_name }}</span>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="tabActiveName === 'order_return'">
                        <el-table-column
                            key="3"
                            min-width="380"
                            label="客户公司名称"
                            show-overflow-tooltip
                            prop="customer_name"
                        >
                            <template slot-scope="{ row }">
                                <span
                                    class="link-label"
                                    @click="handleClickCustomerDetail(row.customer_id, row.customer_name)"
                                    >{{ row.customer_name }}</span
                                >
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column key="4" label="收款方" min-width="380" prop="payee_name" show-overflow-tooltip>
                            <template slot-scope="{ row }">
                                <span>{{ row.payee_name }}</span>
                            </template>
                        </el-table-column>
                    </template>
                    <el-table-column
                        align="right"
                        label="应付总金额"
                        min-width="210"
                        key="5"
                        show-overflow-tooltip
                        prop="total_payable_amount"
                    >
                        <template slot-scope="{ row }">
                            <span
                                v-text="
                                    Number(row.total_payable_amount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                "
                            ></span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="right"
                        label="已付总金额"
                        min-width="210"
                        key="6"
                        show-overflow-tooltip
                        prop="total_paid_amount"
                    >
                        <template slot-scope="{ row }">
                            <span
                                v-text="
                                    Number(row.total_paid_amount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                "
                            ></span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="right"
                        label="未付总金额"
                        min-width="210"
                        key="7"
                        show-overflow-tooltip
                        prop="total_unpaid_amount"
                    >
                        <template slot-scope="{ row }">
                            <span
                                v-text="
                                    Number(row.total_unpaid_amount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                "
                            ></span>
                        </template>
                    </el-table-column>
                    <template>
                        <el-table-column
                            align="right"
                            label="取消总金额"
                            min-width="210"
                            key="8"
                            show-overflow-tooltip
                            prop="total_canceled_amount"
                        >
                            <template slot-scope="{ row }">
                                <span
                                    v-text="
                                        Number(row.total_canceled_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </el-table-column>
                    </template>

                    <el-table-column align="right" label="操作" min-width="90">
                        <template slot-scope="{ row }">
                            <el-link :underline="false" @click="handleClickDetail(row)" type="primary" v-text="'明细'">
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog
                :before-close="handleDialogClose"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :modal-append-to-body="false"
                :visible.sync="detailDialogVisible"
                class="custom_form_dialog custom-form-dialog"
                title="明细"
                width="1110px"
            >
                <div class="custom_form_body">
                    <el-table
                        ref="payableStatisticsDetailTable"
                        :data="detailTableData"
                        border
                        class="custom_table"
                        size="small"
                    >
                        <el-table-column
                            key="1"
                            label="应付编号"
                            min-width="138"
                            prop="payable_no"
                            show-overflow-tooltip
                        >
                            <template slot-scope="{ row }">
                                <span class="link-label" @click="handleClickPayableDetail(row)">{{
                                    row.payable_no
                                }}</span>
                            </template>
                        </el-table-column>
                        <template v-if="tabActiveName == 'purchase' || entity_type == 'supplier'">
                            <el-table-column
                                key="2"
                                label="供应商名称"
                                min-width="164"
                                prop="supplier_name"
                                show-overflow-tooltip
                            >
                                <template slot-scope="{ row }">
                                    <span>{{ row.supplier_name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                key="3"
                                label="采购编号"
                                min-width="142"
                                prop="purchase_no"
                                show-overflow-tooltip
                            >
                                <template slot-scope="{ row }">
                                    <span class="link-label" @click="handleClickRelateId(row.relate_id)">{{
                                        row.purchase_no
                                    }}</span>
                                </template>
                            </el-table-column>
                        </template>
                        <template v-else-if="tabActiveName == 'order_return' || entity_type == 'customer'">
                            <el-table-column
                                key="12"
                                label="客户公司名称"
                                min-width="164"
                                prop="customer_company_name"
                                show-overflow-tooltip
                            >
                                <template slot-scope="{ row }">
                                    <span
                                        class="link-label"
                                        @click="
                                            handleClickCustomerDetail(
                                                row.customer_info && row.customer_info.id,
                                                row.customer_info && row.customer_info.name
                                            )
                                        "
                                        >{{ row.customer_info && row.customer_info.name }}</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                key="13"
                                label="订单编号"
                                min-width="142"
                                prop="order_no"
                                show-overflow-tooltip
                            >
                                <template slot-scope="{ row }">
                                    <span class="link-label" @click="handleClickOrderDetail(row)">{{
                                        row.order_no
                                    }}</span>
                                </template>
                            </el-table-column>
                        </template>

                        <el-table-column
                            key="4"
                            label="审批编号"
                            min-width="102"
                            prop="approval_id"
                            show-overflow-tooltip
                        >
                            <template slot-scope="{ row }">
                                <span class="link-label" @click="handleClickApprovalDetail(row.approval_id)">{{
                                    row.approval_id
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            key="5"
                            label="申请人"
                            min-width="150"
                            prop="application_name"
                            show-overflow-tooltip
                        >
                            <template slot-scope="{ row }">
                                <PersonnelCard v-if="row.uid_info && row.uid_info.id" :userId="row.uid_info.id">
                                    <template slot="container">
                                        <div class="user-avatar-btn">
                                            <img :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg" alt="" />
                                            <span>{{ row.uid_info.name }}</span>
                                        </div>
                                    </template>
                                </PersonnelCard>
                            </template>
                        </el-table-column>
                        <template
                            v-if="
                                (tabActiveName !== 'payableSummary' &&
                                    tabActiveName !== 'purchase' &&
                                    tabActiveName !== 'order_return') ||
                                entity_type == 'payee'
                            "
                        >
                            <el-table-column
                                key="14"
                                label="收款方"
                                min-width="164"
                                prop="payee_name"
                                show-overflow-tooltip
                            >
                                <template slot-scope="{ row }">
                                    <span>{{ row.payee_name }}</span>
                                </template>
                            </el-table-column>
                        </template>
                        <el-table-column
                            key="6"
                            align="right"
                            label="应付金额"
                            min-width="114"
                            prop="payable_amount"
                            show-overflow-tooltip
                        >
                            <template slot-scope="{ row }">
                                <span
                                    v-text="
                                        Number(row.payable_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            key="7"
                            align="right"
                            label="已付金额"
                            min-width="114"
                            prop="paid_amount"
                            show-overflow-tooltip
                        >
                            <template slot-scope="{ row }">
                                <span
                                    v-text="
                                        Number(row.paid_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            key="8"
                            align="right"
                            label="未付金额"
                            min-width="114"
                            prop="unpaid_amount"
                            show-overflow-tooltip
                        >
                            <template slot-scope="{ row }">
                                <span
                                    v-text="
                                        Number(row.unpaid_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </el-table-column>
                        <template>
                            <el-table-column
                                align="right"
                                label="取消金额"
                                min-width="114"
                                key="15"
                                show-overflow-tooltip
                                prop="canceled_amount"
                            >
                                <template slot-scope="{ row }">
                                    <span
                                        v-text="
                                            Number(row.canceled_amount).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></span>
                                </template>
                            </el-table-column>
                        </template>
                        <el-table-column key="9" label="开户行" min-width="150" prop="bank_name" show-overflow-tooltip>
                            <template slot-scope="{ row }">
                                <span>{{ row.bank_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            key="10"
                            label="开户名"
                            min-width="150"
                            prop="account_name"
                            show-overflow-tooltip
                        >
                            <template slot-scope="{ row }">
                                <span>{{ row.account_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column key="11" label="开户账号" min-width="180" prop="account_number">
                            <template slot-scope="{ row }">
                                <span>{{ row.account_number }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-dialog>
            <PayableDetailsDialog
                v-if="payableDetailsDialogVisible"
                :payableDetailsDialogVisible.sync="payableDetailsDialogVisible"
                :payable_no="payable_no"
                @handleDetailToPayment="handleClickPayablePayment"
            />
            <!-- 付款 -->
            <PayablePaymentDialog
                v-if="payablePaymentDialog"
                :payablePaymentDialog.sync="payablePaymentDialog"
                :payable_no="payable_no"
                :type="payablePaymentType"
                :payable_type="payable_type"
                @paymentSuccess="handlePaymentSuccess"
                @handleAgainLookPayableDetail="handleClickPayableDetail"
            />
            <PurchaseDetail
                :purchaseDetailVisible.sync="purchaseDetailVisible"
                v-if="purchaseDetailVisible"
                :purchaseId="purchaseId"
            />
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import {
    PayableSourceList,
    PayablePurchaseSummary,
    PayablePurchaseDetailList,
    PayableOrderRefundSummary,
    PayableOrderRefundDetailList,
    PayableApprovalSummary,
    PayableApprovalDetailList,
    PayableSummary,
    PayableSummaryDetail,
} from "@/api";
import { getDateRange, formatDate } from "@/utils";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import PayableDetailsDialog from "./component/payable_details.vue";
import PayablePaymentDialog from "./component/payable_payment.vue";
import PurchaseDetail from "../../Purchase/component/purchase_detail.vue";
export default {
    name: "PayableStatistics",
    components: { PersonnelCard, PayableDetailsDialog, PurchaseDetail , PayablePaymentDialog},
    props: {
        sourceList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        let that = this;
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            loading: false,
            tabActiveName: "payableSummary",
            source_id: "",
            source_name: "",
            chartTooltipTitle: "",
            tabList: [
                { name: "payableSummary", label: "应付汇总", chartTitle: "全部应付汇总金额" },
                // { name: "purchase", label: "采购应付统计", chartTitle: "采购应付金额趋势" },
                // { name: "order_return", label: "订单退款应付统计", chartTitle: "订单退款应付金额趋势" },
                // { name: "group1", label: "应付控件组", chartTitle: "" },
                // { name: "group2", label: "应付控件组", chartTitle: "" },
                // { name: "group3", label: "应付控件组", chartTitle: "" },
            ],
            searchForm: {
                keyword: "",
                dateType: "month",
                customDate: "",
                date: "",
                date_range: "",
            },
            dateTypeList: [
                { value: "month", label: "本月" },
                { value: "quarter", label: "本季度" },
                { value: "year", label: "本年" },
                { value: "customDate", label: "自定义日期" },
            ],
            chartDateType: "day",
            chartDateTypeList: [
                { name: "日", type: "day" },
                { name: "周", type: "week" },
                { name: "月", type: "month" },
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "本月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(end.getFullYear(), end.getMonth(), 1);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "本季度",
                        onClick(picker) {
                            const start = new Date();
                            start.setMonth(Math.floor(start.getMonth() / 3) * 3, 1);
                            start.setHours(0, 0, 0, 0);

                            const end = new Date(start);
                            end.setMonth(start.getMonth() + 3, 0);
                            end.setHours(23, 59, 59, 999);

                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "本年",
                        onClick(picker) {
                            const start = new Date(new Date().getFullYear(), 0, 1);
                            start.setHours(0, 0, 0, 0);

                            const end = new Date(new Date().getFullYear(), 11, 31);
                            end.setHours(23, 59, 59, 999);

                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
                //限制只能选择一年时间
                disabledDate(time) {
                    if (!that.searchForm.date_range || that.searchForm.date_range[0] == null) return false;

                    let chosedDate = new Date(that.searchForm.date_range[0]);
                    let startyear = chosedDate.getFullYear() - 1;
                    let endYear = chosedDate.getFullYear() + 1;
                    let endDate = endYear + "-" + (chosedDate.getMonth() + 1) + "-" + chosedDate.getDate();
                    let startDate = startyear + "-" + (chosedDate.getMonth() + 1) + "-" + chosedDate.getDate();
                    let _endDate = new Date(endDate);
                    let _startDate = new Date(startDate);
                    //即大于开始时间小于结束时间
                    return time.getTime() > _endDate.getTime() || time.getTime() < _startDate.getTime();
                },
                onPick({ maxDate, minDate }) {
                    //重新设置开始时间
                    if (!minDate) {
                        minDate = new Date();
                    }
                    that.searchForm.date_range = [minDate];
                },
            },
            // 统计数据
            summaryData: {
                total_payable_amount: 0, // 应付总金额
                total_paid_amount: 0, // 已付总金额
                total_unpaid_amount: 0, // 未付总金额
                total_canceled_amount: 0, //取消总金额
                summary_data: {
                    total_payable_amount: 0, // 应付总金额
                    total_paid_amount: 0, // 已付总金额
                    total_unpaid_amount: 0, // 未付总金额
                    total_canceled_amount: 0, //取消总金额
                },
                trend_data: [], // 柱状图数据
                pie_data: [], // 饼图
                list_data: [], // 表格数据
            },
            // 明细弹框
            customer_id: "",
            payment_company_name: "",
            supplier_name: "",
            payee_name: "",
            entity_type: "", // 应付汇总中当前数据的类型  supplier是供应商 customer对应的是订单客户 payee 就是收款公司名称
            detailDialogVisible: false,
            detailTableData: [],
            // 应付详情
            payableDetailsDialogVisible: false,
            payable_no: "",
            // 付款
            payablePaymentDialog: false,
            payablePaymentType: "payment",
            payable_type: "",

            // 采购详情
            purchaseDetailVisible: false,
            purchaseId: "",

        };
    },
    created() {
        const end = new Date();
        const start = new Date(end.getFullYear(), end.getMonth(), 1);
        this.searchForm.date_range = [formatDate(start, "date"), formatDate(end, "date")];
        this.getPayableSourceList();
    },
    mounted() {},
    methods: {
        handleClickTab() {
            this.$nextTick(() => {
                const findTab = this.tabList.find((item) => item.name == this.tabActiveName);
                this.source_id = findTab?.id;
                this.source_name = findTab?.label;
                this.chartTooltipTitle = findTab?.chartTooltipTitle;
                this.$refs.payableStatisticsTable.doLayout();
                this.handleClickSearch();
            });
        },
        // 应付来源
        getPayableSourceList() {
            PayableSourceList().then((res) => {
                if (res.code === 200) {
                    let data = res.data || [];
                    if (data.length) {
                        const tabData = data.map((item) => {
                            return {
                                name: item.source_type == "approval" ? item.source_type + item.id : item.source_type,
                                label: item.name + "统计",
                                chartTitle:
                                    item.source_type == "purchase"
                                        ? "采购应付金额趋势"
                                        : item.source_type == "order_return"
                                        ? "订单退款应付金额趋势"
                                        : item.name + "应付金额",
                                chartTooltipTitle: item.name,
                                id: item.id,
                            };
                        });
                        this.tabList = this.tabList.concat(tabData);
                    }
                    this.$nextTick(() => {
                        this.handleClickSearch();
                    });
                }
            });
        },
        // 时间筛选
        handleClickDateChange(value) {
            if (value == "month" || value == "year") {
                this.searchForm.date = getDateRange(value);
            }
        },
        // 选择自定义时间
        handleCustomDateChange(val) {
            if (val && val.length) {
                this.$refs.customDatePopover.doClose();
            }
        },
        handleClickSearch() {
            if (
                !this.searchForm.date_range ||
                (this.searchForm.date_range && (!this.searchForm.date_range[0] || !this.searchForm.date_range[1]))
            ) {
                const end = new Date();
                const start = new Date(end.getFullYear(), end.getMonth(), 1);
                this.searchForm.date_range = [formatDate(start, "date"), formatDate(end, "date")];
            }
            if (this.tabActiveName == "purchase") {
                this.getPayablePurchaseSummary();
            } else if (this.tabActiveName == "order_return") {
                this.getPayableOrderRefundSummary();
            } else if (this.tabActiveName == "payableSummary") {
                this.getPayableSummary();
            } else {
                this.getPayableApprovalSummary();
            }
        },
        // 图表日期类型切换
        handleClickChartType(type) {
            this.chartDateType = type;
            this.$nextTick(() => {
                this.handleClickSearch();
            });
        },
        // 采购应付统计
        getPayablePurchaseSummary() {
            const params = {
                source_id: this.source_id,
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            PayablePurchaseSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "采购应付金额");
                }
            });
        },
        // 订单退款应付统计
        getPayableOrderRefundSummary() {
            const params = {
                source_id: this.source_id,
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            PayableOrderRefundSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "订单退款应付金额");
                }
            });
        },
        // 应付控件组统计
        getPayableApprovalSummary() {
            const params = {
                source_id: this.source_id,
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            PayableApprovalSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, this.chartTooltipTitle + "应付金额");
                }
            });
        },
        // 应付汇总
        getPayableSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            PayableSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "汇总金额");
                    this.getPieData(this.summaryData.pie_data);
                }
            });
        },
        getBarData(data, tooltipName) {
            let xData = data.map((item) => item.operate_date);
            let sData = data.map((item) => item.total_amount);
            var charts = document.getElementById("container1");
            var myChart = echarts.getInstanceByDom(charts);
            if (myChart) {
                myChart.dispose();
            }
            this.getEchartsBar("container1", xData, sData, tooltipName);
        },
        getEchartsBar(id, xData, sData, tooltipName) {
            var dom = document.getElementById(id);
            this.myChartBar = echarts.init(dom);
            this.myChartBar.clear();
            var color = ["#1890ff", "#52C41B", "#FBAD13", "#FF4D4F", "#00BAAD"];
            var option;
            option = {
                color,
                grid: {
                    left: "10px",
                    top: "10px",
                    right: "0%",
                    bottom: "16px",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "item",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                    triggerOn: "mousemove", // 鼠标移动时触发 tooltip
                    enterable: true,
                    zIndex: 1000, // 提高 tooltip 的层级
                    backgroundColor: "#fffffff",
                    padding: 12,
                    // position: function (point, params, dom, rect, size) {
                    //     return [  point[0], point[1]];
                    // },
                    formatter: function (params) {
                        let html = `<div class="custom_chart_tooltip"><p class="tooltip_title">${
                            params.name
                        }</p><p class="tooltip_content"><span>${tooltipName}</span><span class="count">${
                            params.data + "元"
                        }</span></p></div>`;
                        return html;
                    },
                },
                xAxis: {
                    type: "category",
                    data: xData,
                    axisLabel: {
                        interval: 0,
                        rotate: 0,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "#000000FF",
                    },
                },
                yAxis: {
                    type: "value",
                    name: "", // 设置 y 轴标题
                    min: 0, // 设置最小值
                    scale: true, // 允许动态缩放
                    axisLine: {
                        show: false,
                    },
                    splitLine: {},
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "rgba(0,0,0,.45)",
                        // formatter: function (value) {
                        //     return value / 1000 === 0 ? 0 : value / 1000 + "k";
                        // },
                    },
                },
                series: [
                    {
                        data: sData,
                        type: "bar",
                    },
                ],
            };
            if (option && typeof option === "object") {
                this.myChartBar.setOption(option, true);
            }
            this.handleResize();
            window.addEventListener("resize", this.handleResize);
        },
        toTenThousand(value) {
            const wan = value / 10000;
            // 检查是否为整数
            if (wan % 1 === 0) {
                return wan;
            } else {
                // 可能需要保留两位小数，但去掉末尾的零
                let fixed = wan.toFixed(2);
                // 去掉末尾的零和小数点
                fixed = fixed.replace(/\.?0+$/, "");
                return fixed;
            }
        },
        getPieData(list) {
            let data = list.map((item) => ({
                ...item,
                value: Math.abs(item.total_amount), // 使用绝对值,因为有的数据存在负数

            }));
            let sData = [];
            let sData2 = [];
            const color = [
                "#2990FF",
                "#F0AA32",
                "#5AB333",
                "#16ABA1",
                "#2E7DD9",
                "#9ECF36",
                "#DEAC07",
                "#E44144",
                "#A522BD",
                '#4488E2',
                '#646F9D',
                "#7143DE",
            ];

            data.forEach((item, index) => {
                const s_item = {
                    name: item.source_name + "总金额",
                    // value: item.total_amount,
                    value: item.value,
                    origin_value: item.total_amount,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        // alignTo: "edge",
                        position: "outside",
                        formatter: `{circle|c}{name|{b}}\n{count|${item.total_amount}元}\n`,
                        labelLine: {
                            length: 20,
                        },

                        rich: {
                            count: {
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.45)",
                                padding: [0, 0, 0, 11],
                            },
                            name: {
                                padding: [0, 0, 0, 5],
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.65)",
                            },
                            circle: {
                                width: 6,
                                height: 6,
                                backgroundColor: color[index],
                                borderRadius: 5,
                                color: "rgba(255,255,255,0)",
                            },
                        },
                    },
                };
                const s_item2 = {
                    name: item.source_name + "总金额",
                    // value: item.total_amount,
                    value: item.value,
                    origin_value: item.total_amount,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        normal: {
                            show: true,
                            position: "inner", // 数值显示在内部
                            formatter: "{d}%",
                            color: "#ffffff",
                        },
                    },
                };
                sData.push(s_item);
                sData2.push(s_item2);
            });
            this.getEchartsPie("container2", sData, sData2, color);
        },
        getEchartsPie(id, sData, sData2, color) {
            var dom = document.getElementById(id);
            var myChart = echarts.init(dom);
            myChart.clear();
            var option;
            var that = this;
            option = {
                color,
                title: {
                    text: "",
                },
                tooltip: {
                    trigger: "item",
                    backgroundColor: "#fffffff",
                    padding: 12,
                    formatter: function (params) {
                        let html = "";
                        html += `<div class="custom_chart_tooltip"><p class="tooltip_title"><span>${params.name}</span></p><p class="tooltip_content"><span class="chart_circle_item"><i class="chart_circle" style="background: ${params.color}"></i>${params.data.origin_value}元</span><span class="count">${params.percent}%</span></p></div>`;
                        return html;
                    },
                },
                legend: {
                    show: false,
                    icon: "rect",
                    itemWidth: 10,
                    itemHeight: 8,
                    borderRadius: 2,
                    textStyle: {
                        fontSize: 14, // 设置图例文本的字体大小为 16 像素
                        padding: [5, 0, 5, 0],
                    },
                    left: 0,
                    itemGap: 10,
                    top: 0,
                },
                left: "center",
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
                series: [
                    {
                        name: "",
                        type: "pie",
                        avoidLabelOverlap: true,
                        radius: 80,
                        top: 0,
                        labelLine: {
                            length: 15,
                            showAbove: true,
                            lineStyle: {
                                color: "rgba(0, 0, 0, 0.25)",
                            },
                        },
                        // labelLayout: function (params) {
                        //     const isLeft = params.labelRect.x < myChart.getWidth() / 2;
                        //     const points = params.labelLinePoints;
                        //     // Update the end point.
                        //     points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width;
                        //     return {
                        //         labelLinePoints: points,
                        //     };
                        // },
                        data: sData,
                    },
                    {
                        name: "",
                        type: "pie",
                        avoidLabelOverlap: true,
                        radius: 80,
                        top: 0,
                        data: sData2,
                    },
                ],
            };
            option && myChart.setOption(option, true);
            this.myChartPie = myChart;
            this.handleResizePie();
            window.addEventListener("resize", this.handleResizePie);
        },
        handleResize() {
            if (this.resizeHandler) {
                clearTimeout(this.resizeHandler);
            }
            this.resizeHandler = setTimeout(() => {
                if (this.myChartBar) {
                    this.myChartBar.resize();
                }
            }, 100);
        },
        handleResizePie() {
            if (this.resizeHandlerPie) {
                clearTimeout(this.resizeHandlerPie);
            }
            this.resizeHandlerPie = setTimeout(() => {
                if (this.myChartPie) {
                    this.myChartPie.resize();
                }
            }, 100);
        },
        handleClickDetail(row) {
            this.customer_id = row.customer_id;
            this.supplier_name = row.supplier_name;
            this.payee_name = row.payee_name;
            if (this.tabActiveName == "payableSummary") {
                // 应付汇总
                this.entity_type = row.entity_type;
                this.entity_name = row.entity_name;
                this.entity_id = row.entity_id;
            }
            this.detailDialogVisible = true;
            this.getDetailInfo();
        },
        // 明细弹框
        handleDialogClose() {
            this.detailDialogVisible = false;
            this.customer_id = "";
            this.supplier_name = "";
            this.payee_name = "";
            this.entity_type = "";
            this.entity_id = "";
            this.entity_name = "";
            this.detailTableData = [];
        },
        // 获取明细详情
        getDetailInfo() {
            let params = {
                page: 1,
                pageSize: 1000,
            };
            if (this.tabActiveName == "purchase") {
                params.supplier_name = this.supplier_name;
                PayablePurchaseDetailList(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.detailTableData = data || [];
                    }
                });
            } else if (this.tabActiveName == "order_return") {
                params.customer_id = this.customer_id;
                PayableOrderRefundDetailList(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.detailTableData = data || [];
                    }
                });
            } else if (this.tabActiveName == "payableSummary") {
                params.entity_type = this.entity_type;
                params.entity_id = this.entity_id;
                if (params.entity_type !== "customer") {
                    params.entity_name = this.entity_name;
                }
                PayableSummaryDetail(params).then((res) => {
                    if (res.code === 200) {
                        // const { data, total } = res.data;
                        // this.detailTableData = data || [];
                        this.detailTableData = res.data || [];
                    }
                });
            } else {
                params.source_id = this.source_id;
                params.payee_name = this.payee_name;
                PayableApprovalDetailList(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.detailTableData = data || [];
                    }
                });
            }
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            if (this.detailDialogVisible) {
                this.detailDialogVisible = false;
            }
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(row) {
            this.detailDialogVisible = false;
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_no,
                    name: row.order_no,
                    query_type: "order_no",
                },
            });
        },
        // 查看应付详情
        handleClickPayableDetail(row) {
            if(this.tabActiveName === 'payableSummary') {
                // 应付汇总
                if(row.relate_type) {
                    this.payable_type = row.relate_type || ''
                } else if(this.entity_type == 'customer'){
                    this.payable_type = 'order_return'
                } else if(this.entity_type == 'supplier') {
                    this.payable_type = 'purchase'
                } else {
                    this.payable_type = ''
                }
            } else {
                this.payable_type = this.tabActiveName
            }
            this.payable_no = row.payable_no;
            this.payableDetailsDialogVisible = true;
        },
        // 详情付款
        handleClickPayablePayment(row) {
            this.payablePaymentType = "payment";
            this.payable_no = row.payable_no;
            this.payablePaymentDialog = true;
        },
        // 审批详情
        handleClickApprovalDetail(approval_id) {
            this.$showApprovalDetail({
                approval_id,
            }).then((res) => {});
        },
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.purchaseId = purchaseId;
            this.purchaseDetailVisible = true;
        },
        // 付款成功
        handlePaymentSuccess() {

        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
        if (this.myChartBar) {
            this.myChartBar.dispose();
        }
        if (this.myChartPie) {
            this.myChartPie.dispose();
        }
    },
};
</script>
<style lang="scss" scoped>
.payable_statistics_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .el-tabs {
        ::v-deep {
            .el-tabs__nav {
                margin: 0 16px;
            }

            .el-tabs__header {
                margin: 0;
            }

            .el-tabs__item {
                padding: 0 16px !important;
                height: 48px;
                line-height: 48px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);

                &.is-active {
                    font-weight: 700;
                    color: rgba(41, 144, 255, 1);
                }
            }
        }
    }

    .content_right_wrap {
        flex: 1;
        padding: 16px;
        overflow-y: auto;
    }

    .static_num_top {
        margin-top: 16px;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;

        li {
            min-width: 264px;
            // max-width: calc(100% / 4);
            flex: 1;
            height: 108px;
            border-radius: 8px;
            background-color: rgba(255, 255, 255, 1);
            background-image: url("https://download.hecoos.com/enlightv/2025-00/ee27b3034b8636b993102080c3e1967d.png");
            background-repeat: no-repeat;
            background-size: 103px 103px;
            background-position: calc(100% + 28px) 35px;
            box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);

            p:nth-child(1) {
                height: 44px;
                border-radius: 6px 6px, 0px, 0px;
                background: rgba(41, 144, 255, 0.07);
                text-align: center;
                line-height: 44px;
                font-size: 16px;
                font-weight: 700;
                letter-spacing: 0px;
                color: rgba(102, 102, 102, 1);
            }

            p:nth-child(2) {
                text-align: center;
                line-height: 64px;
                font-size: 22px;
                font-weight: 700;
                letter-spacing: 0px;
                color: rgba(41, 144, 255, 1);
            }
        }
    }

    .chart_box {
        margin: 16px 0;
        width: 100%;
        height: 336px;
        display: flex;
        flex-wrap: nowrap;
        gap: 15px;
        .chart_item_box {
            height: 100%;
            padding: 10px 16px 0;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
            .chart_box_title {
                display: flex;
                height: 28px;
                align-items: center;
                justify-content: space-between;

                & > span {
                    font-size: 16px;
                    font-weight: 500;
                    letter-spacing: -0.2px;
                    line-height: 16px;
                    color: rgba(51, 51, 51, 0.85);
                }

                .chart_box_title_right {
                    display: flex;
                    gap: 12px;

                    span {
                        width: 64px;
                        height: 28px;
                        opacity: 1;
                        text-align: center;
                        line-height: 28px;
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        color: rgba(102, 102, 102, 1);
                        background: rgba(243, 243, 243, 1);
                        border-radius: 12px;
                        cursor: pointer;

                        &.active {
                            color: rgba(41, 144, 255, 1);
                            background: rgba(41, 144, 255, 0.16);
                        }
                    }
                }
            }

            .chart_box_bottom {
                width: 100%;
                margin-top: 10px;
                height: calc(100% - 48px);
                display: flex;
                gap: 15px;

                .echarts_container {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .chart_item_box_bar {
            flex: 1;
        }
        .chart_item_box_flex {
            width: calc(61.48% - 15px);
        }
        .chart_item_box_pie {
            flex-shrink: 0;
            width: 38.52%;
        }
    }
}
</style>
<style lang="scss">
.custom_chart_tooltip {
    background-color: #ffffff;
    padding: 12px;
    border-radius: 2px;
    box-shadow: 0px 2px 4px #0000003f;
    .tooltip_title {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.45);
    }
    .tooltip_content {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.65);
        display: flex;
        justify-content: space-between;
        gap: 24px;
        .count {
            font-weight: 500;
        }
        .chart_circle_item {
            display: flex;
            align-items: center;
            .chart_circle {
                display: inline-block;
                vertical-align: middle;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 9px;
            }
        }
    }
}
</style>
